import 'chart.js';
const queryString = require('query-string');

;(function(window, document, $) {
	const $win = $(window);
	const $doc = $(document);
	const $body = $('body');
	const $wrapper = $('.js-wrapper');
	const $header = $('.js-header');
	const $footer = $('.js-footer');
	const $main = $('.js-main');



	// Check if IE
	function IEdetection() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older, return version number
        return ('IE ' + parseInt(ua.substring(
          msie + 5, ua.indexOf('.', msie)), 10));
    }
    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11, return version number
        var rv = ua.indexOf('rv:');
        return ('IE ' + parseInt(ua.substring(
          rv + 3, ua.indexOf('.', rv)), 10));
    }
    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        //Edge (IE 12+), return version number
        return ('IE ' + parseInt(ua.substring(
          edge + 5, ua.indexOf('.', edge)), 10));
    }
    // User uses other browser
    return ('Not IE');
	}
	var result = IEdetection();
	if (result != 'Not IE') {
		$('body').addClass('isIE');
	}
	console.log(result);

	// Slider photos
	const $sliderPhotos = $('.js-slider-photos');

	$sliderPhotos.each(function() {
		const $slider = $(this);
		const $slides = $slider.find('.js-slider-slides');
		const $sliderPrev = $slider.find('.js-slider-prev');
		const $sliderNext = $slider.find('.js-slider-next');

		$slides.slick({
			rows: 0,
      dots: false,
      arrows: false,
      infinite: false,
      centerMode: false,
      variableWidth: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      vertical: false,
      autoplay: false,
      autoplaySpeed: 4000,
      fade: true,
      cssEase: 'ease-out',
      easing: 'ease-out',
			speed: 800,
			touchThreshold: 7,
			touchMove: false,
			swipe: false,
			waitForAnimate: true,
			draggable: false,
			prevArrow: $sliderPrev,
			nextArrow: $sliderNext,
			centerPadding: '0'
		});
	});

	// Slider photos nav
	const $sliderPhotosNav = $('.js-slider-photos-nav');

	$sliderPhotosNav.each(function() {
		const $slider = $(this);
		const $slides = $slider.find('.js-slider-slides');
		const $sliderPrev = $slider.find('.js-slider-prev');
		const $sliderNext = $slider.find('.js-slider-next');

		jQuery(document).ready(function() {
			$slides.slick({
				rows: 0,
        dots: false,
        arrows: true,
        infinite: false,
        centerMode: false,
        variableWidth: true,
        speed: 300,
        swipe: true,
        accessibility: false,
        slidesToScroll: 1,
        vertical: false,
        autoplay: false,
        autoplaySpeed: 4000,
        fade: false,
        useTransform: false,
        cssEase: 'ease-out',
				speed: 800,
				touchThreshold: 7,
				touchMove: false,
				waitForAnimate: true,
				draggable: false,
				asNavFor: $slider.closest('.js-sliders-photos').find('.js-slider-photos').find('.js-slider-slides'),
				focusOnSelect: true,
				prevArrow: $sliderPrev,
				nextArrow: $sliderNext,
				centerPadding: '0',
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2,
							variableWidth: false,
							slidesToScroll: 1,
							useTransform: true,
							easing: 'ease-out',
							touchMove: true,
							swipe: true,
							draggable: true,
						}
					}
				]
			});
		});

		$slides.on('init breakpoint', function() {
			$slides.find('.slick-slide').wrap('<li></li>');
			$slides.find('.slick-track > li').wrapAll('<ul></ul>');
			$slides.find('.slick-track > ul').wrapAll('<nav></nav>');
		});
	});

	//slide functions
	$('.js-slider-slides').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
		$(this).find('.slick-active').first().attr('aria-label', 'Go to Slide ' + (currentSlide + 1));
		$(this).find('.slick-active').first().attr('aria-current', 'false');
		$(this).find('.slick-slide').eq(nextSlide).attr('aria-label', 'Current Slide, Slide ' + (nextSlide + 1));
		$(this).find('.slick-slide').eq(nextSlide).attr('aria-current', 'true');
		$(this).find('.slick-slide').eq(nextSlide).focus();
		$(this).find('button').each(function() {$(this).removeAttr('aria-hidden')});
	});

	$('.js-slider-slides').on('init', function(slick) {
	$(this).find('.slick-slide').each( function() {
			$(this).attr('aria-label', 'Go to Slide ' + (parseInt($(this).attr('data-slick-index')) + 1));
			$(this).removeAttr('aria-hidden');
		});
	$(this).find('.slick-active').first().attr('aria-label', 'Current Slide, Slide ' + (parseInt($(this).find('.slick-active').attr('data-slick-index')) + 1));
	//$(this).find('.slider__slide').first().trigger('click');
	$('.slick-slide').each( function() {
		$(this).on('keydown', function( e ) {
			if (36 == e.which) {
				e.preventDefault();
				e.stopPropagation();
				$(this).closest('ul').find('button').first().trigger('click');
				$(this).closest('ul').find('button').first().focus();
			}
			if (37 == e.which) {
				if ($(this).closest('ul').find('.slick-active').closest('li').prevAll('li').length == 0) {
					$(this).closest('ul').find('button').last().trigger('click');
					$(this).closest('ul').find('button').last().focus();
				} else {
					$(this).closest('ul').find('.slick-active').closest('li').prevAll('li').first().trigger('click');
					$(this).closest('ul').find('.slick-active').closest('li').prevAll('li').first().focus();
				}
			}
			if (39 == e.which) {
				if ($(this).closest('ul').find('.slick-active').closest('li').nextAll('li').length == 0) {
					$(this).closest('ul').find('button').first().trigger('click');
					$(this).closest('ul').find('button').first().trigger('click');
				} else {
					$(this).closest('ul').find('.slick-active').closest('li').nextAll('li').first().trigger('click');
					$(this).closest('ul').find('.slick-active').closest('li').nextAll('li').first().focus();
				}
			}
			if (35 == e.which) {
				e.preventDefault();
				e.stopPropagation();
				$(this).closest('ul').find('button').last().trigger('click');
				$(this).closest('ul').find('button').last().focus();
			}
		})
	})
})

// alert bar

$('<span class="alert-sep"></span>').insertBefore('.alertbar__actions');

$('.alertbar').each( function() {
	var $count = $(this).find('.alertbar__list').first().find('li').length;
	if ($count > 1) {
		$(this).find('.alertbar__list').first().find('li').last().prepend('<span class="alert-sep"></span>');
	}
})

// print images
let generatePrintImages = function () {
	$("div[style*='url(http']").each( function () {
		let $this = $(this);
		if (!$this.find("img").length) {
			let imageUrl = $this.css("background-image").replace('url("', "").replace('")', '');
			$this.prepend("<img class='print-only print-image' src='"+imageUrl+"'>");
		}
	});
}
generatePrintImages();
setInterval(generatePrintImages, 2000);

// style real-img-container images

// print images
let positionRealImages = function () {
	$(".real-img-container[data-vpos][data-hpos] > img").each( function () {
		let $this = $(this);
		let vPos = $this.parent().data("vpos");
		let hPos = $this.parent().data("hpos");
		if (vPos.length && hPos.length) {
			//this.style.objectFit = 'none';
			this.style.objectPosition = hPos+" "+vPos;
		}
	});
}
positionRealImages();
setInterval(positionRealImages, 2000);

// non ms-landing contact form styilng fixes

// general country contact selectbox form fix
$('.address_country').each( function() {
	$(this).addClass('container--select frame frame--select frame-size2').find('select').first().addClass('vtc--select');
})

// general radio restructuring/styling
$('.ginput_container_radio').each( function() {
if ($(this).closest('li').hasClass('gender')) {
	$(this).closest('.gender').find('ul').first().addClass('radios-icon');
	$(this).closest('.gender').find('li').each( function() {
		$(this).addClass('radio-icon').removeClass('frame');
		$(this).find('input').first().removeClass('field ff-call js-field-input');
		$(this).find('label').first().addClass('radio__label');
	})
} else {
		$(this).find('ul').first().addClass('radios').removeClass('frame__inner frame gfield_radio');
		$(this).find('li').each( function() {
			$(this).addClass('radio').removeClass('frame__inner frame');
			$(this).find('input').removeClass('field ff-call js-field-input');
			$(this).find('label').first().addClass('radio__label');
		})
	}
})

// general checkbox restructuring/styling
setInterval(function() {

		$('.ginput_container_checkbox').each( function() {
			if (!$(this).find('svg').length) {
				$(this).find('ul').first().addClass('checkboxes frame').removeClass('gfield_checkbox').find('li').each( function() {
					$(this).addClass('checkbox').find('label').first().addClass('checkbox__label').append('<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="16.094" height="15.796" viewBox="0 0 16.094 15.796" focusable="false"><path data-name="Shape 1749" d="M221.755,4335.75l-9.391,13.415a1.369,1.369,0,0,1-2.221.037l-2.389-3.185" transform="translate(-206.705 -4334.706)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></svg>');
				});
			}
		});

}, 1000);



// general button fixes
$('.gform_button').each( function() {
	$('<button type="submit" id="' + $(this).attr('ID') + '" class="btn btn--icon" onclick="' + $(this).attr('onclick') + '" onkeypress="' + $(this).attr('onkeypress') + '"><span class="btn__inner"><span class="btn__content"><span class="btn__text">' + $(this).attr('value') + '</span></span></span>').insertAfter($(this));
	$(this).remove();
})

// microsite landing page restructuring/restyling
$('.ms-landing').each( function() {
	// gform heading restyling
	$('.gf_page_steps').each( function() {
		$(this).addClass('contact__nav ff-brand fw-bd');
		$(this).find('.gf_step').each( function() {
			$(this).addClass('link-contact link__inner');
			$('.link__inner').each( function() {
				$(this).find('.gf_step_number').add('.gf_step_label').addClass('link__text fz-sm');
			});
		})
	})

	$('.gform_heading').css('style="display:none;"');

	// gform active tab restyling
	$('.gf_step').change( function() {
		if ($(this).hasClass('gf_step_active')) {
			$('.gf_step').add('active').removeClass('active');
			$(this).addClass('active');
		}
	})

	// gform wrapper restyling
	$('.gform_wrapper').addClass('contact__inner shadow').removeClass('gform_wrapper');
	$('.gform_page').first().addClass('contact__content shell').removeClass('gform_page');
	$('.gform_page_fields').each( function() {
		$(this).addClass('contact__group');
	});
	$('.contact__group').find('ul').each( function() {
		$(this).addClass('frame').removeClass('form_sublabel_below description_below').find('li').each( function() {
				$(this).addClass('frame__inner frame').removeClass('gfield field_sublabel_below field_description_below gfield_visibility_visible gform_fields');
		});
	});
	$('.frame__inner').find('input').each( function() {
		$(this).addClass('field ff-call js-field-input');
	})
	$(this).find('input').each( function() {
		$(this).addClass('field ff-call js-field-input').removeClass('medium');
	})

	// gform footer restyling
	$('.gform_page_footer').addClass('contact__actions').removeClass('gform_page_footer');
	$('.contact__actions').find('.button').first().addClass('btn btn--icon').removeClass('gform_next_button button');

	// ul wrapping of content rows
	$('li.gsection').each( function() {
		$(this).closest('li').prevUntil('li.gsection').wrapAll('<ul class="content__row"> </ul>');
		$(this).addClass('contact__title contact__title--big');
		$(this).find('h2').first().addClass('fz-sm fw-bd color-graydark ff-brand tt-up').append('<span class="separator color-grayalt"></span>');
	});

	// Changes to Birthday/Date Dropdown fields
	$('.ginput_container_date').closest('.ginput_container').addClass('container--select frame frame--select frame--size2').closest('.clear-multi').addClass('contact__row');
	$('.clear-multi').first().parent('.ginput_container').removeClass('ginput_container ginput_container_date container--select frame frame--select frame--size2').find('.container--select').each( function() {
		$(this).removeClass('gfield_date_dropdown_month gfield_date_dropdown_day gfield_date_dropdown_year ginput_container ginput_container_date frame frame--select frame--size2').addClass('frame frame--select frame--size2');
		$(this).find('select').each( function() {
			$(this).addClass('vtc--select');
			$(this).wrapAll('<div class="container--select"> </div>');
			$(this).closest('.container--select').prepend('<label class="form__label frame__label ff-brand fw-md"><span class="fz-sm"> ' + $(this).attr('aria-label') +'</span></label>');
			$(this).closest('.container--select').append('<div class="frame__invalid">Not entered correctly</div>');
			$(this).find('option').first().text('- Select -');
		});
	})

	// controls added svg's for gender to gender radio inputs
	$('.ginput_container_radio').find('input[type=radio]').each( function() {
		if ($(this).val() == 'Male') {
			$('<div class="icon"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="45" height="45" viewBox="0 0 45 45"><title>Male avatar</title><g data-name="Group 4969" transform="translate(-232.031 -982)"><g data-name="Group 4967"><g data-name="Group 4968"><g data-name="Ellipse 2834" transform="translate(232.031 982)" class="circle-outline" fill="none" stroke-width="2"><circle cx="22.5" cy="22.5" r="22.5" stroke="none"></circle><circle cx="22.5" cy="22.5" r="21.5" fill="none"></circle></g></g></g><g data-name="Avatars / Geometric-Men-People / people-man-8" transform="translate(-67.969 846)"><g data-name="Group 11" transform="translate(309.25 144.75)"><g><path data-name="Oval 6" d="M320.75,158.749a7,7,0,1,0-7-7A7,7,0,0,0,320.75,158.749Z" transform="translate(-307.75 -144.75)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path data-name="Shape 49" d="M314.491,147.35a11.635,11.635,0,0,0,12.917,2.6" transform="translate(-307.503 -143.883)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path data-name="Shape 50" d="M309.25,170.343a13.007,13.007,0,0,1,9-12.373l4,3.373,4-3.373a13,13,0,0,1,9,12.373" transform="translate(-309.25 -140.344)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path data-name="Shape 51" d="M326.538,159.751A12.923,12.923,0,0,0,323,157.97l-4,3.373,6,4Z" transform="translate(-306.001 -140.344)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path data-name="Shape 52" d="M320.884,161.343l-4-3.373a12.952,12.952,0,0,0-3.537,1.781l1.537,5.592Z" transform="translate(-307.885 -140.344)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path data-name="Shape 53" d="M319,169.5v-9" transform="translate(-306.001 -139.501)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path data-name="Shape 54" d="M322,166.5h4" transform="translate(-305.001 -137.501)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></g></g></g></svg></div>').insertBefore($(this).parent('li').find('label').first());
		}
		if ($(this).val() == 'Female') {
			$('<div class="icon"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="45" height="45" viewBox="0 0 45 45"><title>Female avatar</title><g data-name="Group 4970" transform="translate(-414.031 -982)"><g data-name="Ellipse 2835" transform="translate(414.031 982)" fill="none" class="circle-outline" stroke-width="2"><circle cx="22.5" cy="22.5" r="22.5" stroke="none"></circle><circle cx="22.5" cy="22.5" r="21.5" fill="none"></circle></g><g data-name="Avatars / Geometric-Women-People / people-woman-1" transform="translate(115.031 3)"><g data-name="Group 73" transform="translate(308.861 988.75)"><g><path data-name="Shape 453" d="M329.364,1012.246a18.713,18.713,0,0,0,4.36-1.293,1.93,1.93,0,0,0,.981-2.521l-1.769-4.127a5.763,5.763,0,0,1-.468-2.279v-2.669a10.606,10.606,0,1,0-21.212,0v2.669a5.786,5.786,0,0,1-.468,2.279l-1.768,4.127a1.928,1.928,0,0,0,.98,2.521,18.694,18.694,0,0,0,4.359,1.293" transform="translate(-308.861 -988.75)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path data-name="Shape 454" d="M333.862,1012.964a13.477,13.477,0,0,0-24.365,0" transform="translate(-308.68 -984.038)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path data-name="Shape 455" d="M321.223,1012.7l2.615-6.539" transform="translate(-305.331 -983.776)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path data-name="Shape 456" d="M314.689,1006.164l2.615,6.539" transform="translate(-307.197 -983.776)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path data-name="Shape 457" d="M320.473,993.25s-1.842,4.628-6.468,4.815a6.75,6.75,0,1,0,12.931,0C322.317,997.874,320.473,993.25,320.473,993.25Z" transform="translate(-307.473 -987.465)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></g></g></g></svg></div>').insertBefore($(this).parent('li').find('label').first());
		}
		if ($(this).val() == 'Nonbinary') {
			$('<div class="icon"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="45" height="45" viewBox="0 0 45 45"><title>Nonbinary avatar</title><g data-name="Group 4971" transform="translate(-618.031 -982)"><g data-name="Ellipse 2833" transform="translate(618.031 982)" fill="none" class="circle-outline" stroke-width="2"><circle cx="22.5" cy="22.5" r="22.5" stroke="none"></circle><circle cx="22.5" cy="22.5" r="21.5" fill="none"></circle></g><g data-name="Avatars / Geometric-Men-People / people-man-7" transform="translate(-113.969 894.25)"><g data-name="Group 10" transform="translate(741.25 96.75)"><g><path data-name="Shape 45" d="M741.25,122.5a13,13,0,0,1,26,0" transform="translate(-741.25 -92.5)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path data-name="Shape 46" d="M747.25,110.249v1a5,5,0,0,0,10,0v-1" transform="translate(-739.25 -92.25)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path data-name="Shape 47" d="M752.444,96.75a6.99,6.99,0,0,0-5.776,3.047c.776,3.953,8.463,7.6,14.776,5.953C760.444,101.75,759.444,96.75,752.444,96.75Z" transform="translate(-739.444 -96.75)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path data-name="Shape 48" d="M759.334,105.368c-5.711.352-11.681-2.875-12.36-6.333a7,7,0,0,0,9.66,9.777" transform="translate(-739.75 -95.988)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></g></g></g></svg></div>').insertBefore($(this).parent('li').find('label').first());
		}
	});

	// specific assignment of rows and columns based on styling
	$('.address_city').add('.address_state').add('.address_zip').addClass('frame form__controls ff-brand js-field').wrapAll('<ul class="contact__row"></ul>');

	$('.gform_fields').find('li.gsection').last().closest('li').nextAll('li').wrapAll('<ul class="contact__row"></ul>');

	$('li.gfield_html').last().prevAll('li').wrapAll('<ul class="contact_column"> </ul>');

	// controls the assignment of phone and email icons to phone and email fields
	$('.contact_column').find('li').each( function() {
		$(this).addClass('frame frame--icon form__controls ff-brand js-field');
		$(this).find('.ginput_container').first().addClass('frame__inner');
		$(this).find('label').each( function() {
			$(this).remove();
		});
		if($(this).find('.ginput_container').first().hasClass("ginput_container_email")){
			var $labelText = 'Email';
			var $class = "input--email";
		} else {
			var $labelText = 'Phone';
			var $class = "";
		}
		$(this).find('input').first().addClass('field-input-icon ' + $class + '').closest('.ginput_container').prepend('<div><label class="form_label frame_label" for="' + $(this).attr("ID") + '"><span class="fz-sm">' + $labelText + '</span></label></div>');
	});

	// Specific labels removal
	$(this).find('.clear-multi').closest('.gfield_label').remove();
	$(this).find('.hidden_label').find('.gfield_label').first().remove();
	$(this).find('.gender').first().find('.gfield_label').first().remove();

	// tempInt is the variable that controls the next target page, iterates by one with each page once initialized
	var $tempInt = 2;
	$('.contact__actions').each( function() {
		if ($(this).find('input').length == 1) {
			$(this).find('input').last().replaceWith('<button type="button" class="btn btn--icon" onclick="jQuery(&quot;#gform_target_page_number_7&quot;).val(&quot;' + $tempInt + '&quot;);  jQuery(&quot;#gform_7&quot;).trigger(&quot;submit&quot;,[true]); " onkeypress="if( event.keyCode == 13 ){ jQuery(&quot;#gform_target_page_number_7&quot;).val(&quot;' + $tempInt + '&quot;);  jQuery(&quot;#gform_7&quot;).trigger(&quot;submit&quot;,[true]); } "><span class="btn__inner"><span class="btn__content"><span class="btn__text">NEXT STEP</span><span class="btn__icon"><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="17.5" height="16.434" viewBox="0 0 17.5 16.434"><title>Arrow right</title><g><g data-name="Regular 73" transform="translate(0.75 0.75)"><path data-name="Shape 253" d="M239.75,442h16" transform="translate(-239.75 -434.533)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path data-name="Shape 254" d="M251.75,446.433l7.467-7.467L251.75,431.5" transform="translate(-243.217 -431.5)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></g></svg></span></span></span></span></button>');
		}

		if(($(this).find('input').length > 1) && ($(this).find('input').length < 3)) {
			$(this).find('input').first().replaceWith('<button type="button" class="btn btn--icon prev" onclick="jQuery(&quot;#gform_target_page_number_7&quot;).val(&quot;' + ($tempInt - 2) + '&quot;);  jQuery(&quot;#gform_7&quot;).trigger(&quot;submit&quot;,[true]); " onkeypress="if( event.keyCode == 13 ){ jQuery(&quot;#gform_target_page_number_7&quot;).val(&quot' + ($tempInt - 2) + '&quot;);  jQuery(&quot;#gform_7&quot;).trigger(&quot;submit&quot;,[true]); } " ><span class="btn__inner"><span class="btn__content"><span class="btn__icon"><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="17.5" height="16.434" viewBox="0 0 17.5 16.434"><title>Arrow right</title><g><g data-name="Regular 73" transform="translate(0.75 0.75)"><path data-name="Shape 253" d="M239.75,442h16" transform="translate(-239.75 -434.533)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path data-name="Shape 254" d="M251.75,446.433l7.467-7.467L251.75,431.5" transform="translate(-243.217 -431.5)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></g></svg></span></span><span class="btn__text">PREVIOUS</span></span></span></span></button> ');

			$(this).find('input').last().replaceWith('<button type="button" class="btn btn--icon" onclick="jQuery(&quot;#gform_target_page_number_7&quot;).val(&quot;' + $tempInt + '&quot;);  jQuery(&quot;#gform_7&quot;).trigger(&quot;submit&quot;,[true]); " onkeypress="if( event.keyCode == 13 ){ jQuery(&quot;#gform_target_page_number_7&quot;).val(&quot;' + $tempInt + '&quot;);  jQuery(&quot;#gform_7&quot;).trigger(&quot;submit&quot;,[true]); } "><span class="btn__inner"><span class="btn__content"><span class="btn__text">NEXT STEP</span><span class="btn__icon"><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="17.5" height="16.434" viewBox="0 0 17.5 16.434"><title>Arrow right</title><g><g data-name="Regular 73" transform="translate(0.75 0.75)"><path data-name="Shape 253" d="M239.75,442h16" transform="translate(-239.75 -434.533)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path data-name="Shape 254" d="M251.75,446.433l7.467-7.467L251.75,431.5" transform="translate(-243.217 -431.5)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></g></svg></span></span></span></span></button>');
			// Wraps the buttons into a flex object if more than one exists, this way we can use space-between on flex to ensure previous and next buttons are in proper position
			$(this).find('button').wrapAll('<div class="action__group"></div>');
		}

		if ($(this).find('input').length > 2) {
			$(this).find('input').first().replaceWith('<button type="button" class="btn btn--icon prev" onclick="jQuery(&quot;#gform_target_page_number_7&quot;).val(&quot;' + ($tempInt - 2) + '&quot;);  jQuery(&quot;#gform_7&quot;).trigger(&quot;submit&quot;,[true]); " onkeypress="if( event.keyCode == 13 ){ jQuery(&quot;#gform_target_page_number_7&quot;).val(&quot' + ($tempInt - 2) + '&quot;);  jQuery(&quot;#gform_7&quot;).trigger(&quot;submit&quot;,[true]); } " ><span class="btn__inner"><span class="btn__content"><span class="btn__icon"><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="17.5" height="16.434" viewBox="0 0 17.5 16.434"><title>Arrow right</title><g><g data-name="Regular 73" transform="translate(0.75 0.75)"><path data-name="Shape 253" d="M239.75,442h16" transform="translate(-239.75 -434.533)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path data-name="Shape 254" d="M251.75,446.433l7.467-7.467L251.75,431.5" transform="translate(-243.217 -431.5)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></g></svg></span></span><span class="btn__text">PREVIOUS</span></span></span></span></button> ');

			$(this).find('button').last().addClass('submit').find('.btn__content').first().append('<span class="btn__icon"><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="17.5" height="16.434" viewBox="0 0 17.5 16.434"><title>Arrow right</title><g><g data-name="Regular 73" transform="translate(0.75 0.75)"><path data-name="Shape 253" d="M239.75,442h16" transform="translate(-239.75 -434.533)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path data-name="Shape 254" d="M251.75,446.433l7.467-7.467L251.75,431.5" transform="translate(-243.217 -431.5)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></g></svg></span></span>')

			$(this).find('button').wrapAll('<div class="action__group"></div>');
		}

		$tempInt++;
	})

	// adds last row class to last row of page
	$('.contact_row').last().addClass('last_row');

	// last section of contact form is a column, this specific wrapping targets that
	$('.contact__row').last().find('.gfield_html').last().next('li').first().wrapAll('<ul class="contact_column"></ul>');

	// Appends the last question of the page to the text
	$('.contact_column').last().prepend('<legend class="contact__title"><span class="fz-sm fw-bd color-graydark ff-brand tt-up">Would You Like Important Updates and Reminders Via Text?</span></legend>');
});

	// capitalizes all labels no matter what
	$('.gform_body label').each( function() {
		$(this).html($(this).html().toUpperCase());
	})

	// validation message fix on general and microsite page
	$('.validation_message').each( function() {
		$(this).addClass('frame__invalid');
		$(this).closest('.gfield_error').addClass('invalid');
	})

	// Replace tag name but keep element contents
	function changeTag(el, newTagName, keepAttributes) {
		const newEl = document.createElement(newTagName);

		// Copy the children
		while (el.firstChild) {
			newEl.appendChild(el.firstChild); // *Moves* the child
		}

		// Copy the attributes
		if (keepAttributes) {
			for (var i = el.attributes.length - 1; i >= 0; --i) {
				newEl.attributes.setNamedItem(el.attributes[i].cloneNode());
			}
		}

		// Replace it
		el.parentNode.replaceChild(newEl, el);
	}


	// Gallery sorting
	const $isotope = $('.js-isotope');

	if ($isotope) {
		window.onload = initIso();
		window.addEventListener("resize", initIso());
		setInterval(initIso, 1500);
	}

	function initIso() {
		$isotope.each(function() {
			const $isotope = $(this);

			$isotope.isotope({
				itemSelector: '.js-isotope-item',
				masonry: {
					columnWidth: '.isotope-sizer'
				}
			});
		});
	}





	// gdpr stuff
	if (localStorage.getItem('acceptsCookies') != "yes") {
		$(".gdpr-container").addClass("active");
	}
	$(".gdpr-accept").click( function (e) {
		e.preventDefault();
		localStorage.setItem('acceptsCookies', "yes");
		$(".gdpr-container").removeClass("active");
    if ($("html").attr("data-whatinput") == "keyboard") {
      $("a.skip-link").get(0).focus();
    }
	});

	// alertbar stuff
	// only two possible alerts at a time
	var $itemNum = $('.alertbar__list').find('.alertbar__item').length;
	if ($itemNum == 1) {

		// key is equal to title lowercase without spaces, check local storage for this title, if it exists do not display
		var $key = $('.alertbar__list').find('.alertbar__item').first().find('.alertbar__title').text().replace(/\s/g,'').toLowerCase();
		if (localStorage.getItem($key) != "yes") {
			$('.alertbar__list').find('.alertbar__item').first().addClass('active');
		}

		// close alertbar when close button is clicked add key to local storage
		$('.alertbar__close').on('click', function() {
			localStorage.setItem($key, 'yes');
			$('.alertbar__list').find('.alertbar__item').first().removeClass('active');
			$(this).closest('.alertbar').removeClass('active');
		});
	}

	if ($itemNum == 2) {
		var $item1 = $('.alertbar__list').find('.alertbar__item').first();
		var $item2 = $('.alertbar__list').find('.alertbar__item').last();
		var $key1 = $item1.find('.alertbar__title').text().replace(/\s/g,'').toLowerCase();
		var $key2 = $item2.find('.alertbar__title').text().replace(/\s/g,'').toLowerCase();

		if (localStorage.getItem($key1) != 'yes') {
			$item1.addClass('active');
		}
		if (localStorage.getItem($key2) != 'yes') {
			$item2.addClass('active');
		}

		// if two alerts are present on users screen at once a new style class is necessary to contrl max-width
		if ($('.alertbar__list').find('.active').length == 2) {
			$('.alertbar__list').addClass('two-alerts');
		}

		$('.alertbar__close').on('click', function() {
			localStorage.setItem($key1, 'yes');
			localStorage.setItem($key2, 'yes');
			$item1.removeClass('active');
			$item2.removeClass('active');

			$(this).closest('.alertbar').removeClass('active');
		})
	}

	// if any alertbar items have active classes allow the alertbar to be active
	if ($('.alertbar').find('.alertbar__item.active').length > 0) {
		$('.alertbar').addClass('active');
	}


	// scholarships list querying and display things
	let scholarshipPagination = 20;
	let $scholarshipsContainer = $( '#scholarships-live-grid-container' );
	let grabScholarshipsResults = function () {

		$scholarshipsContainer.removeClass("live--loaded");
		$scholarshipsContainer.addClass("live--loading");
    $body.addClass("has-loading");
		// compile options
		let type = $( "input.filter--scholarship-type:checked" ).map(function() { return $(this).data("termid"); }).get();
		let school = $( "input.filter--school:checked" ).map(function() { return $(this).data("termid"); }).get();

		let text = $("#scholarships-keyword-search").val();
		let displayStyle = $(".page-template-scholarships-list .filters--view .active button").data("view");

		$.ajax({
			 type: 'POST',
			 url: '/wp-admin/admin-ajax.php',
			 dataType: "html", // add data type
			 data: { action : 'render_scholarships_list_results', type: JSON.stringify(type), school: JSON.stringify(school), text: text, limit: scholarshipPagination, display: displayStyle },
			 success: function( response ) {
				 //console.log( response );
				 $scholarshipsContainer.html( response );
				 $scholarshipsContainer.addClass("live--loaded");
		 		 $scholarshipsContainer.removeClass("live--loading");
         $body.removeClass("has-loading");
				 resizeAllGridItems();
			 }
		});
	};
	$('input.filter--scholarship-type, input.filter--school').change(function(event) {
		event.preventDefault();
		grabScholarshipsResults();
	});
	$('#scholarships-keyword-submit, .page-template-scholarships-list .filters--view button').click(function(event) {
		event.preventDefault();
		setTimeout(grabScholarshipsResults, 2); // got to give the display select time to register
	});
	$(".page-template-scholarships-list").on("click", "#scholarships-show-more", function (event) {
		event.preventDefault();
		scholarshipPagination += 20;
		grabScholarshipsResults();
	});
	$(".page-template-scholarships-list button[type='reset']").click( function (event) {
		event.preventDefault();
		$('input.filter--scholarship-type, input.filter--school').prop('checked',false);
		$("#scholarships-keyword-search").val('');
		scholarshipPagination = 20;
		setTimeout(grabScholarshipsResults, 2);
	});
	$win.on("resize", function () {
		if ($win.width() < 768) {
			$(".scholarship-grid").removeClass("masonry");
		}
		else {
			$(".scholarship-grid").addClass("masonry");
		}
	})







	// directory list querying
	window.directoryPage = 1;
	let totalPages = $("li:nth-last-child(2) button[data-page]").data("page");
	let $directoryContainer = $( '#directory-live-container' );
	let grabDirectoryResults = function () {
		//console.log("hi");
	  $directoryContainer.removeClass("live--loaded");
	  $directoryContainer.addClass("live--loading");
	  // compile options
	  let prefilter = $( ".directory-container .link-big.active" ).map(function() { return $(this).data("prefilter"); }).get(0);
	  let text = $("#directory-keyword-search").val();
		//let text = $('*[id*="directory-keyword-search"]:visible').val();
		console.log(text);
	  $.ajax({
	     type: 'POST',
	     url: '/wp-admin/admin-ajax.php',
	     dataType: "html", // add data type
	     data: { action : 'render_directory_results', prefilter: prefilter, text: text, page: window.directoryPage, columns: 3},
	     success: function( response ) {
	       //console.log( response );
	       $directoryContainer.html( response );
	       $directoryContainer.addClass("live--loaded");
	       $directoryContainer.removeClass("live--loading");

				 totalPages = $("li:nth-last-child(2) button[data-page]").data("page");
				 $( '.directory-container .pagination__prev' ).toggleClass("visible", (window.directoryPage > 1));
		 		$( '.directory-container .pagination__next' ).toggleClass("visible", (window.directoryPage < totalPages));
	     }
	  });
	};
	$('#directory-keyword-submit, .directory-container .link-big[role="tab"]').click(function(event) {
	  event.preventDefault();
		window.directoryPage = 0;
	  setTimeout(grabDirectoryResults, 2); // got to give the display select time to register
	});

	$( '.directory-container.js-tabs' ).on("click", ".pagination button", function (event) {

		console.log(this);
		if ($(this).hasClass("pagination__prev")) {
			window.directoryPage = Math.max(window.directoryPage-1, 0);
		}
		else if ($(this).hasClass("pagination__next")) {
			window.directoryPage = Math.min(window.directoryPage+1, totalPages);
		}
		else {
			window.directoryPage = $(this).data("page");
		}
		$( '.directory-container .pagination__next' ).removeClass("visible");
	  setTimeout(grabDirectoryResults, 2); // got to give the display select time to register
	});
	// mobile directory filter events
	if (window.directoryFilters) {
		for (let i = 0; i < 4; i++) {
			let prefilter = window.directoryFilters[i];
			//console.log(filter);
			let $directoryContainer = $( '#directory-live-container-'+i );

			window["grabDirectoryResults"+i] = function () {
			  $directoryContainer.removeClass("live--loaded");
			  $directoryContainer.addClass("live--loading");
			  // compile options
			  let text = $("#directory-keyword-search-"+i).val();
			  $.ajax({
			     type: 'POST',
			     url: '/wp-admin/admin-ajax.php',
			     dataType: "html", // add data type
			     data: { action : 'render_directory_results', prefilter: prefilter, text: text, page: window.directoryPage, columns: 2},
			     success: function( response ) {
			       //console.log( response );
			       $directoryContainer.html( response );
			       $directoryContainer.addClass("live--loaded");
			       $directoryContainer.removeClass("live--loading");

						 totalPages = $("li:nth-last-child(2) button[data-page]").data("page");
						 $( '.directory-container .pagination__prev' ).toggleClass("visible", (window.directoryPage > 1));
				 		$( '.directory-container .pagination__next' ).toggleClass("visible", (window.directoryPage < totalPages));
			     }
			  });
			};
			$('#directory-keyword-submit-'+i).click(function(event) {
			  event.preventDefault();
				window.directoryPage = 0;
			  setTimeout(window["grabDirectoryResults"+i], 2); // got to give the display select time to register
			});
			$( '#accordion-section-1-'+i ).on("click", ".pagination button", function (event) {

				console.log(this);
				if ($(this).hasClass("pagination__prev")) {
					window.directoryPage = Math.max(window.directoryPage-1, 0);
				}
				else if ($(this).hasClass("pagination__next")) {
					window.directoryPage = Math.min(window.directoryPage+1, totalPages);
				}
				else {
					window.directoryPage = $(this).data("page");
				}
				$( '#accordion-section-1-0'+i+' .pagination__next' ).removeClass("visible");
			  setTimeout(window["grabDirectoryResults"+i], 2); // got to give the display select time to register
			});
		}
	}










	//majors list
	let majorPagination = 20;
  let $majorsContainer = $("#majors-live-grid-container");
	let grabMajorsResults = function () {
		let useMobileSelectors = ($win.width() < 1024);
		let locationSelector = "#select-filter-locations";
		let jobSelector = "#select-filter-jobs";
		let employerSelector = "#select-filter-employers";

		if (useMobileSelectors) {
			locationSelector = "#select-filter-locations-mobile";
			jobSelector = "#select-filter-jobs-mobile";
			employerSelector = "#select-filter-employers-mobile";
		}

    $majorsContainer.removeClass("live--loaded");
		$majorsContainer.addClass("live--loading");

	  // compile options
		let school = $( "input.filter--school:checked" ).map(function() { return $(this).data("termid"); }).get();
	  let type = $( "input.filter--degree-type:checked" ).map(function() { return $(this).data("termid"); }).get(); // degree type
		let format = $( "input.filter--learning-format:checked" ).map(function() { return $(this).data("termid"); }).get();
		let location = $( locationSelector ).val();
		let placement = $( "input[name='placement-rate']:checked" ).map(function() { return { min: $(this).data("min"), max: $(this).data("max")}; }).get();
		let pay = $( "input[name='median-pay']:checked" ).map(function() { return { min: $(this).data("min"), max: $(this).data("max")}; }).get();
		let job = $( jobSelector ).val();
		let employer = $( employerSelector ).val();

	  let text = $("#majors-keyword-search").val();
	  let displayStyle = $(".page-template-majors .filters--view .active button").data("view");

		console.log(placement);

		let data = {
			action : 'render_programs_list_results',
			type: JSON.stringify(type),
			school: JSON.stringify(school),
			format: JSON.stringify(format),
			location: JSON.stringify(location),
			placement: JSON.stringify(placement),
			pay: JSON.stringify(pay),
			job: job,
			employer: employer,
			text: text,
			limit: majorPagination,
			display: displayStyle
		};
		console.log(data);
	  $.ajax({
	     type: 'POST',
	     url: '/wp-admin/admin-ajax.php',
	     dataType: "html", // add data type
	     data: data,
	     success: function( response ) {
	       //console.log( response );
	       $majorsContainer.html( response );
         $directoryContainer.addClass("live--loaded");
	       $directoryContainer.removeClass("live--loading");
				 resizeAllGridItems();
				 initializeTabRemotes();
	     }
	  });
	};
	$('input.filter--degree-type, .filter--learning-format, input.filter--school, input[name="placement-rate"], input[name="median-pay"], #select-filter-jobs, #select-filter-employers, #select-filter-locations, #select-filter-employers-mobile, #select-filter-locations-mobile, #select-filter-jobs-mobile').change(function(event) {
	  event.preventDefault();
		console.log("hi");
		console.log($(event.target).val());
	  grabMajorsResults();
	});
	$('#majors-keyword-submit, .page-template-majors .filters--view button').click(function(event) {
	  event.preventDefault();
	  setTimeout(grabMajorsResults, 2); // got to give the display select time to register
	});
	$(".page-template-majors").on("click", ".majors-show-more", function (event) {
	  event.preventDefault();
	  majorPagination += 20;
	  grabMajorsResults();
	});
	$(".page-template-majors button[type='reset']").click( function (event) {
	  event.preventDefault();
	  $('input.filter--major-type, input.filter--school, input.filter--learning-format, input[name="placement-rate"], input[name="median-pay"]').prop('checked',false);
	  $("#majors-keyword-search, #select-filter-locations, #select-filter-jobs, #select-filter-employers").val('');
	  majorPagination = 20;
	  setTimeout(grabMajorsResults, 2);
	});
















	// Select
	/*
	const mdcSelects = document.querySelectorAll('.mdc-select');

	for (let i = 0; i < mdcSelects.length; i++) {
		let mdcSelect = mdcSelects[i];

		let newSelect = new MDCSelect(mdcSelect);
		newSelect.listen('MDCSelect:change', () => {
			$(".mdc-list-item").removeAttr("aria-selected");
			$(".mdc-list-item[data-value='"+newSelect.value+"']").attr("aria-selected", true);

		  grabLabResults();
		});

	};
	*/
	$('#class-year, #majors__list').change(function(event) {
		grabLabResults();
	});

	// the lab querying
	let grabLabResults = function () {
		$.ajax({
			 type: 'POST',
			 url: '/wp-admin/admin-ajax.php',
			 dataType: "html", // add data type
			 data: { action : 'render_the_lab_results', year: $("#class-year").val(), major: $("#majors__list").val() },
			 success: function( response ) {
				 //console.log( response );
				 $( '.page-template-the-lab .section--grid .section__inner' ).replaceWith( response );
			 }
	 	});
	}
	if ($("body").hasClass("page-template-the-lab")) {
		grabLabResults();
	}








	// Chart
	let $desktopCircleCharts = $('.desktop-circle-chart');
	$desktopCircleCharts.each( function (index, element) {
		let $this = $(this);
		let vtcRate = $this.attr("data-vtc-rate");
		let nationalRate = $this.attr("data-national-rate");
		let chart = new Chart(this, {
			type: 'doughnut',
			data: {
				labels: [],
				datasets: [
					{
						data: [vtcRate, (100 - vtcRate)],
						backgroundColor: [
							'rgba(112,191,71,1)',
							'rgba(211,235,198,1)'
						],
						borderColor: [
							'rgba(255,255,255,1)',
							'rgba(255,255,255,1)'
						],
						borderWidth: 0,
						weight: 10
					},
					{
						data: [100],
						backgroundColor: [
							'rgba(255,255,255,1)',
						],
						borderColor: [
							'rgba(255,255,255,1)',
						],
						borderWidth: 0,
						weight: 2
					},
					{
						data: [nationalRate, (100 - nationalRate)],
						backgroundColor: [
							'rgba(146,146,146,1)',
							'rgba(201,201,201,1)'
						],
						borderColor: [
							'rgba(255,255,255,1)',
							'rgba(255,255,255,1)'
						],
						borderWidth: 0,
						weight: 9
					}
				]
			},
			options: {
				scales: {
					animation: {
						animateScale: true,
						animateRotate: true
					}
				},
				cutoutPercentage: 30
			}
		});
	});


	// Chart
	let $mobileCircleCharts = $('.mobile-circle-chart');
	$mobileCircleCharts.each( function (index, element) {
		let $this = $(this);
		let vtcRate = $this.attr("data-vtc-rate");
		let nationalRate = $this.attr("data-national-rate");
		let chart = new Chart(this, {
			type: 'doughnut',
			data: {
				labels: [],
				datasets: [
					{
						data: [vtcRate, (100 - vtcRate)],
						backgroundColor: [
							'rgba(112,191,71,1)',
							'rgba(211,235,198,1)'
						],
						borderColor: [
							'rgba(255,255,255,1)',
							'rgba(255,255,255,1)'
						],
						borderWidth: 0,
						weight: 10
					},
					{
						data: [100],
						backgroundColor: [
							'rgba(255,255,255,1)',
						],
						borderColor: [
							'rgba(255,255,255,1)',
						],
						borderWidth: 0,
						weight: 2
					},
					{
						data: [nationalRate, (100 - nationalRate)],
						backgroundColor: [
							'rgba(146,146,146,1)',
							'rgba(201,201,201,1)'
						],
						borderColor: [
							'rgba(255,255,255,1)',
							'rgba(255,255,255,1)'
						],
						borderWidth: 0,
						weight: 9
					}
				]
			},
			options: {
				scales: {
					animation: {
						animateScale: true,
						animateRotate: true
					}
				},
				cutoutPercentage: 30
			}
		});
	});


	// Chart
	let $singleCharts = $('.js-chart-single');
	$singleCharts.each( function (index, element) {
		let $this = $(this);
		let rate = $this.data("rate");
		let chart = new Chart(this, {
			type: 'doughnut',
			data: {
				labels: [],
				datasets: [
					{
						data: [rate, 100 - rate],
						backgroundColor: [
							'rgba(112,191,71,1)',
							'rgba(211,235,198,1)'
						],
						borderColor: [
							'rgba(255,255,255,1)',
							'rgba(255,255,255,1)'
						],
						borderWidth: 0,
						weight: 10
					},
					{
						data: [100],
						backgroundColor: [
							'rgba(255,255,255,1)',
						],
						borderColor: [
							'rgba(255,255,255,1)',
						],
						borderWidth: 0,
						weight: 2
					},
					{
						data: [45, 55],
						backgroundColor: [
							'rgba(255,255,255,1)',
							'rgba(255,255,255,1)'
						],
						borderColor: [
							'rgba(255,255,255,1)',
							'rgba(255,255,255,1)'
						],
						borderWidth: 0,
						weight: 9
					}
				]
			},
			options: {
				scales: {
					animation: {
						animateScale: true,
						animateRotate: true
					}
				},
				cutoutPercentage: 30
			}
		});
	});




	// fast facts pagination
	let $programList = $(".program-list-area.acticle--pagination");
	let $programPrevButton = $programList.find(".pagination__prev");
	let $programNextButton = $programList.find(".pagination__next");
	let programListPage = 0;
	let programListData = window["_vtcprograms"];
	if ($programList.length && programListData) {
		let updateProgramList = function (page) {
			programListPage = page;
			let template = `
			<li>
			  <a href="{LINK}" class="link-arrow link-arrow--right color-blue">
			    <span class="link__content">
			      {TITLE}&nbsp;&nbsp;<span style="display:inline-block;" class="link__arrow">&nbsp<span class="icon"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="5.57" height="9.872" viewBox="0 0 5.57 9.872"><title>Arrow right</title><g data-name="Group 51"><g data-name="Group 51" transform="translate(0.75 9.122) rotate(-90)"><g data-name="Regular 51"><path data-name="Shape 225" d="M7,0,3.665,3.335a.233.233,0,0,1-.33,0L0,0" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></g></g></svg></span></span>
			    </span>
			  </a>
			</li>
			`;
			let newProgramList = programListData[programListPage];

			let programListHtml = "";
			newProgramList.forEach((program) => {
		    programListHtml += template.replace("{LINK}", program.link).replace("{TITLE}", program.title);
		  });
			$programList.find(".lists .list").html(programListHtml);

			// pager/nav visual update
			$programList.find(".pagination .list li").removeClass("active");
			$programList.find("[data-pager='"+programListPage+"']").parent().addClass("active");
			$programPrevButton.toggleClass("visible", (programListPage > 0));
			$programNextButton.toggleClass("visible", (programListPage < programListData.length-1));
		}
		updateProgramList(0);
		$programList.find("[data-pager]").on("click", function (event) {
			event.preventDefault();
			updateProgramList($(this).data("pager"));
		});
		$programList.find(".pagination__prev").on("click", function (event) {
			event.preventDefault();
			event.stopImmediatePropagation();
			updateProgramList(Math.max(programListPage-1, 0));

		});
		$programList.find(".pagination__next").on("click", function (event) {
			event.preventDefault();
			event.stopImmediatePropagation();
			updateProgramList(Math.min(programListPage+1, programListData.length-1));
		});
	}


	//majors detail/ majors detail -alt pagination functions
	$('.pagination__inner').find('.list').find('button').each( function() {
    $(this).on('click', function() {
      $(this).closest('.list').find('button').each( function() {
        $(this).removeClass('active');
        $(this).attr('aria-current', 'false');
        $(this).closest('li').removeClass('active');
        $(this).attr('aria-label', 'Go to Page ' + ($(this).closest('li').prevAll('li').length + 1));
      });
      $(this).addClass('active');
      $(this).attr('aria-current', 'true');
      $(this).closest('li').addClass('active');
      $(this).attr('aria-label', 'Current Page, Page ' + ($(this).closest('li').prevAll('li').length + 1));
    })
  });

  $('.pagination__inner').find('.pagination__prev').each( function() {
    $(this).on('click', function() {
      var index = $(this).closest('.pagination__inner').find('ul').first().find('li').filter('.active').prevAll('li').length;
      $(this).closest('.pagination__inner').find('ul').first().find('li').eq(index - 1).find('button').first().trigger('click');
    })
  })

  $('.pagination__inner').find('.pagination__next').each( function() {
    $(this).on('click', function() {
      var index = $(this).closest('.pagination__inner').find('ul').first().find('li').filter('.active').prevAll('li').length;
      $(this).closest('.pagination__inner').find('ul').first().find('li').eq(index + 1).find('button').first().trigger('click');
    })
  })








	// Mobile nav
	const $nav = $('.js-nav');
	const $navTrigger = $('.js-nav-trigger');
	let cachedScrollPos;
	$nav.find('button').each( function() {
		$(this).attr('tabindex', '-1');
	})
	$nav.find('nav__actions').first().find('a').first().attr('tabindex', '-1');
	$(window).on('keydown', function( e ) {
			if (27 == e.which && $nav.hasClass('active')) {
				closeNav();
			}
	});
	function openNav() {
		cachedScrollPos = $doc.scrollTop();
		$body.addClass('freeze').css({ top: -cachedScrollPos });
		$header.addClass('open');
		$wrapper.addClass('header-opened');
		$navTrigger.add($nav).addClass('active');
		$nav.find('button').each( function() {
			$(this).attr('tabindex', '0');
		})
		$nav.find('nav__actions').first().find('a').first().attr('tabindex', '0');

	}

	function closeNav() {
		$body.removeClass('freeze').css({ top: 'auto' });
		$win.scrollTop(cachedScrollPos);
		$header.removeClass('open');
		$wrapper.removeClass('header-opened');
		$navTrigger.add($nav).removeClass('active');
		$nav.find('button').each( function() {
			$(this).attr('tabindex', '-1');
		});
		$nav.find('nav__actions').first().find('a').first().attr('tabindex', '-1');
	}

	$navTrigger.on('click', function(event) {
		event.preventDefault();

		if (!$nav.hasClass('active')) {
			openNav();
		} else {
			closeAccordsWithin($nav);
			closeDropdownsWithin($nav);
			closeNav();
		}
	});

	$win.on('resize', function() {
		if ($win.width() > 1023 && $nav.hasClass('active')) {
			closeAccordsWithin($nav);
			closeDropdownsWithin($nav);
			closeNav();
		}
	});

	//Menus
	const $menu = $('.js-menu');
	const $menuTrigger = $('.js-menu-trigger');

	$menuTrigger.each(function() {
		const $menuTrigger = $(this);
		const $menu = $($menuTrigger.data('target'));

		function openMenu() {
			cachedScrollPos = $doc.scrollTop();
			if ($menu.parent().hasClass("menu-mobile--filters")) {
				$win.scrollTop(0);
			}
			$body.addClass('freeze');//.css({ top: -cachedScrollPos });

			$header.addClass('open');
			$wrapper.addClass('header-opened');
			$menuTrigger.add($menu).addClass('active');
		}

		function closeMenu() {
			$body.removeClass('freeze');//.css({ top: 'auto' });
			$win.scrollTop(cachedScrollPos);
			$header.removeClass('open');
			$wrapper.removeClass('header-opened');
			$menuTrigger.add($menu).removeClass('active');
		}



		$menuTrigger.on('click', function(event) {
			if (!$menu.hasClass('active')) {
				openMenu();
			} else {
				closeAccordsWithin($menu);
				closeDropdownsWithin($menu);
				closeMenu();
			}
		});

		$win.on('resize', function() {
			if ($win.width() > 1023 && $menu.hasClass('active')) {
				closeAccordsWithin($menu);
				closeDropdownsWithin($menu);
				closeTabsWithin($menu);
				closeMenu();
			}
		});
	});


	// Dropdown
	const $dropdown = $('.js-dropdown');

	function closeDropdownsWithin(scope) {
		scope.find('.js-dropdown').removeClass('active');
	}

	function closeNearDropdowns(near) {
		const $dropdowns = near.closest('.js-dropdowns');

		$dropdowns.find('.js-dropdown').removeClass('active');
	}

	$dropdown.each(function() {
		const $dropdown = $(this);
		const $dropdownTrigger = $dropdown.find('.js-dropdown-trigger');

		$dropdownTrigger.on('click', function(event) {
			const $dropdownTrigger = $(this);

			event.preventDefault();

			if ($dropdownTrigger.closest('.js-dropdown').hasClass('active')) {
				closeNearDropdowns($dropdownTrigger);
			} else {
				closeNearDropdowns($dropdownTrigger);
				$dropdownTrigger.closest('.js-dropdown').addClass('active');
			}
		});
	});

	// Accordions
	const $accord = $('.js-accordion');

	function closeAccordsWithin(scope) {
		scope.find('.js-accordion')
			.add(scope.find('.js-accordion-trigger'))
				.removeClass('active');
		scope.find('.js-accordion-trigger').attr('aria-expanded', 'false');
		scope.find('.js-accordion-expand').stop().slideUp('300');
	}

	function closeNearAccord(near) {
		const $accord = near.closest('.js-accordion');

		$accord
			.add($accord.find('.js-accordion-trigger'))
				.removeClass('active');
		$accord.find('.js-accordion-trigger').attr('aria-expanded', 'false');
		$accord.find('.js-accordion-expand').stop().slideUp('300');
	}

	function closeNearAccords(near) {
		const $accords = near.closest('.js-accordions');

		$accords.find('.js-accordion')
			.add($accords.find('.js-accordion-trigger'))
				.removeClass('active');
		$accords.find('.js-accordion-trigger').attr('aria-expanded', 'false');
		$accords.find('.js-accordion-expand').stop().slideUp('300');
	}

	$accord.each(function() {
		const $accord = $(this);
		const $accordTrigger = $accord.find('.js-accordion-trigger');
		const $accordExpand = $accord.find('.js-accordion-expand');

		if (!$accord.hasClass('js-accordion-solid active')) {
			$accordExpand.hide();
		}

		$accordTrigger.on('click', function(event) {
			const $accordTrigger = $(this);

			event.preventDefault();

			if ($accordTrigger.hasClass('active')) {
				closeNearAccord($accordTrigger);
			} else {
				$accordExpand.stop().slideDown('300');
				$accord.add($accordTrigger).addClass('active');
				$accordTrigger.attr('aria-expanded', 'true');
				if ($(this).closest('.js-accordions').next().hasClass('gridtabs')) {
				  const $accordIndex = $accord.prevAll('.accordion').length;
					$('.gridtabs .active').removeClass('active');
					$('#gridtab-' + $accordIndex).addClass('active');
					console.log('fired');
				}
			}
		});
	});

	$('.js-accordions').on('keydown', function(event) {
	  //console.log(event);
	  let $this = $(this);
	  let $accTriggers = $this.find(".js-accordion-trigger");
	  let $firstAccTrigger = $accTriggers.first();
	  let $lastAccTrigger = $accTriggers.last();
	  let $currentAccTrigger = $this.find('.js-accordion-trigger:focus');
	  let $currentAccTriggerIndex = $accTriggers.index($currentAccTrigger);
	  let $nextAccTrigger = $accTriggers.get($currentAccTriggerIndex+1);
	  let $prevAccTrigger = $accTriggers.get($currentAccTriggerIndex-1);

	  if (event.key == "ArrowLeft" || event.key == "ArrowUp" ) {
	    // find previous acc
	    // if we are on first => activate last
	    if ($currentAccTrigger.is($firstAccTrigger)) {
	      $lastAccTrigger.focus();
	    }
	    else { // else activate previous
	      $prevAccTrigger.focus();
	    }
	    event.preventDefault();
	  }
	  // strike down or right in the acc
	  if (event.key == "ArrowRight" || event.key == "ArrowDown") {
	    // find next acc
	    if ($currentAccTrigger.is($lastAccTrigger)) {
	      $firstAccTrigger.focus();
	    }
	    else { // else activate previous
	      $nextAccTrigger.focus();
	    }
	    event.preventDefault();
	  }

	  if (event.key == "Home") {
	    // find first acc
	    $firstAccTrigger.focus();
	    event.preventDefault();
	  }
	  if (event.key == "End") {
	    // find first acc
	    $lastAccTrigger.focus();
	    event.preventDefault();
	  }
	});

	$('.js-accordion-trigger').keydown( function(e) {
    switch(e.which) {
      case 35:
        e.preventDefault();
        e.stopPropagation();
        $(this).closest('.section__inner').find('.js-accordion-trigger').last().focus();
      break;

      case 36:
        e.preventDefault();
        e.stopPropagation();
        $(this).closest('.section__inner').find('.js-accordion-trigger').first().focus();
      break;

      case 38:
        e.preventDefault();
        e.stopPropagation();
        if ($(this).closest('.section__inner').find('.js-accordion-trigger').first().is(":focus")) {
          $(this).closest('.section__inner').find('.js-accordion-trigger').last().focus();
        } else {
          $(this).closest('.section__inner').find('.js-accordion-trigger').first().focus();
        }

      break;

      case 40:
        e.preventDefault();
        e.stopPropagation();
        if ($(this).closest('.section__inner').find('.js-accordion-trigger').last().is(":focus")) {
          $(this).closest('.section__inner').find('.js-accordion-trigger').first().focus();
        } else {
          $(this).closest('.section__inner').find('.js-accordion-trigger').last().focus();
        }
      break;

      default: return;
    }
  })


	function closeTabsWithin(scope) {
		scope.closest('.js-tabs').find('.js-tab-remote')
			.add(scope.closest('.js-tabs').find('.js-tab'))
				.removeClass('active').attr('tabindex', -1);
		scope.closest('.js-tabs').find('.js-tab-remote').attr('aria-selected', 'false');
		scope.closest('.js-tabs').find('.js-tab').attr('tabindex', 0);
	}
	function closeNearTabs(near) {
		let $tabs = near.closest('.js-tabs');
		$tabs.find('.js-tab-remote')
			.add($tabs.find('.js-tab'))
				.removeClass('active').attr('tabindex', -1);
		$tabs.find('.js-tab-remote').attr('aria-selected', 'false');
		$tabs.find('.js-tab').attr('tabindex', 0);
	}


	// Tab remote
	let initializeTabRemotes = function () {
		console.log("initing tabremotes");
		let $tabRemote = $('.js-tab-remote');



		$tabRemote.each(function() {
			let $tabRemote = $(this);
			let $target = $($tabRemote.data('target'));
			let $supplement = $($tabRemote.data('supplement'));


			$win.on('load', function() {
				$tabRemote.each(function() {
					if (!$tabRemote.hasClass('active')) {
						if (!$target.hasClass('js-tab-simple')) {
							$target.hide();
						}
					}
				});
			});

			$tabRemote.on('click', function(event) {
				console.log("clickedTabby");
				console.log(this);
				let $tabRemote = $(this);
				$tabRemote.focus();
				event.preventDefault();

				if (!$tabRemote.hasClass('active')) {
					if (!$target.hasClass('js-tab-simple')) {
						$target.show();
					}
					// for comparison charts
					$(".gridtab").removeClass("active");
					$supplement.addClass("active");

					closeNearTabs($tabRemote);

					$tabRemote
						.add($tabRemote.closest('.js-tabs').find($target))
							.addClass('active').removeAttr('tabindex');
						$tabRemote.attr('aria-selected', 'true');
						$tabRemote.closest('.js-tabs').find('.js-tab').attr('tabindex', 0);


				} else {
					if (!$tabRemote.hasClass('js-tab-remote-solid')) {
						closeNearTabs($tabRemote);
					}
				}
			});
		});

		$tabRemote.keydown(function(e) {
			switch(e.which) {
				case 35:
					e.preventDefault();
					e.stopPropagation();
					$(this).closest('div').find('.js-tab-remote').last().focus();
					$(this).closest('div').find('.js-tab-remote').last().trigger('click');
				break;

				case 36:
					e.preventDefault();
					e.stopPropagation();
					$(this).closest('div').find('.js-tab-remote').first().focus();
					$(this).closest('div').find('.js-tab-remote').first().trigger('click');
				break;

				case 37:
					if (($(this).closest('div').find('.tabs-nav--vertical').length > 0) || 	($(this).closest('div').find('.horizontal-tab').length > 0)) {
						break;
					}
					e.preventDefault();
					e.stopPropagation();
					if ($(this).closest('div').find('.js-tab-remote').first().hasClass('active')) {
						$(this).closest('div').find('.js-tab-remote').last().focus();
						$(this).closest('div').find('.js-tab-remote').last().trigger('click');
						$(this).removeClass('active');
					} else {
						$(this).closest('div').find('.js-tab-remote').first().focus();
						$(this).closest('div').find('.js-tab-remote').first().trigger('click');
						$(this).removeClass('active');
					}
				break;

				case 39:
					if (($(this).closest('div').find('.tabs-nav--vertical').length > 0) || ($(this).closest('div').find('.horizontal-tab').length > 0)) {
						break;
					}
					e.preventDefault();
					e.stopPropagation();
					if ($(this).closest('div').find('.js-tab-remote').last().hasClass('active')) {
						$(this).closest('div').find('.js-tab-remote').first().focus();
						$(this).closest('div').find('.js-tab-remote').first().trigger('click');
						$(this).removeClass('active');
					} else {
						$(this).closest('div').find('.js-tab-remote').last().focus();
						$(this).closest('div').find('.js-tab-remote').last().trigger('click');
						$(this).removeClass('active');
					}
				break;

				default: return;
			}
			$('.js-tab-remote').each( function() {
				if ($(this).hasClass('active')) {
					$(this).attr('tabIndex', '0');
				} else {
					$(this).attr('tabIndex', '-1');
				}
			});
		})
	};

	initializeTabRemotes();







	$win.on('resize', function() {
		if ($win.width() < 1024) {
			closeTabsWithin($('.js-tabs-desktop'));
		}
	});

	$('.js-tabs').on('keydown', function(event) {
    //console.log(event);
		let $this = $(this);
		let $tabRemotes = $this.find(".js-tab-remote");
		let $firstTabRemote = $tabRemotes.first();
		let $lastTabRemote = $tabRemotes.last();
		let $currentTabRemote = $this.find('.js-tab-remote[aria-selected="true"]');
		let $currentTabRemoteIndex = $tabRemotes.index($currentTabRemote);
		let $nextTabRemote = $tabRemotes.get($currentTabRemoteIndex+1);
		let $prevTabRemote = $tabRemotes.get($currentTabRemoteIndex-1);
		let $currentTab = $this.find(".active[role='tabpanel']");

		if (event.key == "Tab") {

			if ($currentTabRemote.is(":focus")) {
				// go to tabpanel
				if (event.shiftKey) {

				}
				else {
					event.preventDefault();
					$currentTab.focus();
				}

      }
			else {
				// let it happen
			}
		}

    if (event.key == "ArrowLeft" || event.key == "ArrowUp" ) {
      // find previous tab
      // if we are on first => activate last
			if ($(this).hasClass('horizontal-tab') && event.key == "ArrowUp") {
				$firstTabRemote.click();
				$firstTabRemote.focus();
			} else {
				if ($currentTabRemote.is($firstTabRemote)) {
					$lastTabRemote.click();
					$lastTabRemote.focus();
				}
				else { // else activate previous
					$prevTabRemote.click();
					$prevTabRemote.focus();
				}
			}
      event.preventDefault();
    }
    // strike down or right in the tab
    if (event.key == "ArrowRight" || event.key == "ArrowDown") {
			if ($(this).hasClass('horizontal-tab') && event.key == "ArrowDown") {
				$lastTabRemote.click();
				$lastTabRemote.focus();
			} else {
				// find next tab
				if ($currentTabRemote.is($lastTabRemote)) {
					$firstTabRemote.click();
					$firstTabRemote.focus();
				}
				else { // else activate previous
					$nextTabRemote.click()
					$nextTabRemote.focus();
				}
			}
      event.preventDefault();
    }

		if (event.key == "Home") {
      // find first tab
      $firstTabRemote.click();
			$firstTabRemote.focus();
      event.preventDefault();
    }
		if (event.key == "End") {
      // find first tab
      $lastTabRemote.click();
			$lastTabRemote.focus();
      event.preventDefault();
    }
  });

	// Dynamic margin
    /* COMMENTED OUT - Causing spacing issues with desktop nav dropdown
	$win.on('load scroll resize', function() {
		const $dynamicMargin = $('.js-dynamic-margin');

		$dynamicMargin.each(function() {
			const $dynamicMargin = $(this);
			const headerHeight = $('.js-header').outerHeight();

			$dynamicMargin.css({
				'margin-top': headerHeight + 'px'
			});
		});
	});
    */

	// Dynamic padding
    /* COMMENTED OUT - Causing spacing issues with mobile menu flyout
	$win.on('load scroll resize', function() {
		const $dynamicPadding = $('.js-dynamic-padding');

		$dynamicPadding.each(function() {
			const $dynamicPadding = $(this);
			const headerHeight = $('.js-header').outerHeight();

			$dynamicPadding.css({
				'padding-top': headerHeight + 'px'
			});
		});
	});
    */

	// Radio button
	const $radioBtn = $('.js-radio-btn');

	$radioBtn.each(function () {
		const $radioBtn = $(this);

		$radioBtn.on('click', function (event) {
			event.preventDefault();

			if (!$radioBtn.hasClass('active')) {
				const $radioBtns = $radioBtn.closest('.js-radio-btns');

				$radioBtns.find('.js-radio-btn').each( function(){ $(this).removeClass('active').find('button').first().attr("aria-pressed", 'false')});
				$radioBtn.addClass('active').find('button').first().attr("aria-pressed", 'true');
			}
		});
	});

  // general radio ADA fixes
	$(':radio').each( function() {
	$(this).on('click', function() {
		$(this).attr('aria-checked', 'true');
		$(this).attr('tabindex', '0');
		$(this).closest('.radio-icon').nextAll('.radio-icon').each( function() {
			$(this).find(':radio').attr('aria-checked', 'false');
		});
		$(this).closest('.radio').nextAll('.radio').each( function() {
			$(this).find(':radio').attr('aria-checked', 'false');
			$(this).find(':radio').attr('tabindex', '-1');
		})
		$(this).closest('.radio-icon').prevAll('.radio-icon').each( function() {
			$(this).find(':radio').attr('aria-checked', 'false');
		})
		$(this).closest('.radio').prevAll('.radio').each( function() {
			$(this).find(':radio').attr('aria-checked', 'false');
			$(this).find(':radio').attr('tabindex', '-1');
		})
	})
})

	// Field states
	const $field = $('.js-field');

	$field.each(function() {
		const $field = $(this);
		const $fieldInput = $field.find('.js-field-input');

		$fieldInput.on('keyup', function() {
			if ($fieldInput.val().length > 0) {
				if (!$field.hasClass('filled')) {
					$field.addClass('filled');
				}
			} else {
				if ($field.hasClass('filled')) {
					$field.removeClass('filled');
				}
			}
		});
	});

	// Hover-elevate
	const $elevate = $('.js-elevate');

	$elevate.each(function() {
		const $elevate = $(this);
		const $elevateTrigger = $elevate.find('.js-elevate-trigger');
		$elevateTrigger.on('focus', function() {
			if (!$elevate.hasClass('hover')) {
				$elevate.addClass('hover');
			}
		});

		$elevateTrigger.on('mouseenter', function() {
			if (!$elevate.hasClass('hover')) {
				$elevate.addClass('hover');
			}
		});

		$elevateTrigger.on('focusout', function() {
			if ($elevate.hasClass('hover')) {
				$elevate.removeClass('hover');
			}
		});

		$elevateTrigger.on('mouseleave', function() {
			if ($elevate.hasClass('hover')) {
				$elevate.removeClass('hover');
			}
		});
	});

	$('.social-card').each( function() {
    $(this).find('.js-elevate-trigger').hover( function() {
      $(this).closest('.social-card').addClass( "hover" );
    }, function() {
      $(this).closest('.social-card').removeClass( "hover" );
    });
    $(this).find('.js-elevate-trigger').on('focus', function() {
      $(this).closest('.social-card').addClass( "hover" );
    })
    $(this).find('.js-elevate-trigger').off('focus', function() {
      $(this).closest('.social-card').removeClass( "hover" );
    });
	});

	$('input:checkbox').each( function(){
    $(this).attr('aria-checked', 'false');
  });

  $('input:checkbox').click(function() {
    if ($(this).attr('aria-checked') === 'true') {
      $(this).attr('aria-checked', 'false');
    } else {
      $(this).attr('aria-checked', 'true');
    }
  });


   function resizeGridItem(item){
     var grid = document.getElementsByClassName("grid__col")[0];
     var rowHeight = 5;
     var rowGap = 5;
     var rowSpan = Math.floor((item.querySelector('.card').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap)) + 4;
     item.style.gridRowEnd = "span "+rowSpan;
   }

   function resizeAllGridItems(){
     var allItems = document.getElementsByClassName("grid-item");
     for(var x=0;x<allItems.length;x++){
       resizeGridItem(allItems[x]);
     }
		 //generatePrintImages();
   }

   function resizeInstance(instance){
       var item = instance.elements[0];
     resizeGridItem(item);
   }

	 if ($('.masonry')[0]) {

     window.onload = resizeAllGridItems();
     window.addEventListener("resize", resizeAllGridItems);
		 setTimeout(resizeAllGridItems, 1000);
		 $("#main-partner-list").imagesLoaded().progress(resizeAllGridItems).done(resizeAllGridItems);

     var allItems = document.getElementsByClassName("grid-item");
     for(var x=0;x<allItems.length;x++){
       //imagesLoaded( allItems[x], resizeInstance);
     }
   }





	var $mainMenu = $('.js-main-menu');

	$('.js-main-menu').on('keydown', function(event) {
		if (event.key == "Tab" && !event.shiftKey) {
				// go to tabpanel
				event.preventDefault();
				$("[data-idy='header-feature-button']").focus();
				closeOtherSubs();
		}
	});

	function closeOtherSubs(near) {
		$('.js-main-menu').find('.menu-button').attr('aria-expanded', 'false');
		$('.js-main-menu').find('.menu-button').removeClass('active');
		$('.js-main-menu').find('.js-submenu').removeClass('active');
		$('.js-main-menu').find('.js-submenu').hide();
	}

	$("[data-idy='header-feature-button']").keydown( function (event) {
		console.log(event.keyCode);
		if (event.keyCode == 9 && event.shiftKey) {
			console.log("true");
			event.preventDefault();
			event.stopPropagation();
			$('.js-main-menu > a').first().focus();
			if ($('.menu-mobile').first().hasClass('active')) {
				$('.menu-mobile').first().find('.nav').first().find('button').last().focus();
			}
		}
		else {
			closeOtherSubs();
		}
	});

	$('.menu-button').keydown(function(e){

		if ([35,36,37,38,39,40,32,13,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90].indexOf(e.keyCode)==-1) {

			return;
		}



		var link = $(this);
		console.log(e.keyCode == 9);
		console.log(event.shiftKey);
		console.log(link.parents('[aria-label="main menu"]').length);
		if (e.keyCode == 9 && event.shiftKey && link.parents('[aria-label="main menu"]').length) {
			event.preventDefault();
			event.stopPropagation();
			$('.header a.logo').first().focus();

			return;
		}

		switch (e.keyCode){

			case 35:
				e.preventDefault();
				e.stopPropagation();
				link.parent('.js-main-menu').nextAll('.js-main-menu').last().find('.menu-button').focus();
				console.log("35");
			break;

			case 36:
				e.preventDefault();
				e.stopPropagation();
				link.parent('.js-main-menu').prevAll('.js-main-menu').last().find('.menu-button').focus();
				console.log("36");
			break;

			case 37:
				e.preventDefault();
				e.stopPropagation();
				console.log("37");
				if(link.parent('li').prevAll('li').filter(':visible').last().first().length == 0) {
					link.parent('li').nextAll('li').filter(':visible').last().find('a').first().focus();
				} else {
					openMenu($(this));
					link.parent('li').prevAll('li').filter(':visible').first().find('a').first().focus();
				}
				break;

			case 38:
				e.preventDefault();
				e.stopPropagation();
				var dropdown = link.parent('li').find('li');
				openMenu(link.parent('li'));
				setTimeout(() => { dropdown.find('a').last().focus(); }, 100);
				console.log("38");
				break;

			case 39:
				openMenu($(this));
				e.preventDefault();
				e.stopPropagation();
				console.log("39");
				if(link.parent('li').nextAll('li').filter(':visible').first().length == 0) {
					console.log("first-ptopino");
					link.parent('li').prevAll('li').filter(':visible').last().find('a').first().focus();
				} else {
					console.log("2nd-ptopino");
					link.parent('li').nextAll('li').filter(':visible').first().find('a').first().focus();
				}
				break;

			case 40:
			console.log("40");
			e.preventDefault();
			e.stopPropagation();
			var dropdown = link.parent('li').find('li');
			if (!link.hasClass('active')){
				openMenu(link.parent('li'));
			}
			setTimeout(() => { dropdown.find('a').first().focus(); }, 100);
			break;

			case 32:
			case 13:
				e.preventDefault();
				e.stopPropagation();
				var dropdown = link.parent('li').find('li');
				openMenu(link.parent('.js-main-menu'));
				setTimeout(() => { dropdown.find('a').first().focus(); }, 100);
			break;

			default:
				var value = String.fromCharCode(e.keyCode).toLowerCase();
				var refocused = false;
				if (refocused == false){
					link.parent('.js-main-menu').nextAll('.js-main-menu').each( function() {
						if (value == $(this).find('.menu-button').find('.link__content').text().substring(0,1).toLowerCase()){
							$(this).find('.menu-button').focus();
							refocused = true;
							return false;
						}
					});
				}
				if (refocused == false){
					link.parent('.js-main-menu').prevAll('.js-main-menu').each( function() {
						if (value == $(this).find('.menu-button').find('.link__content').text().substring(0,1).toLowerCase()){
							$(this).find('.menu-button').focus();
						}
					});
				}

			break;
		}
	});

	$('.link').add('.link-icon').add('.card__link').keydown(function(e){

		if ([27,35,36,37,38,39,40,32,13,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90].indexOf(e.keyCode)==-1) {
			return;
		}

		var link = $(this);

		switch (e.keyCode){

			case 27:
				e.preventDefault();
				e.stopPropagation();
				openMenu(link.closest('.js-main-menu'));
				setTimeout(() => {link.closest('.js-main-menu').find('.menu-button').focus();}, 100);
				console.log("27");
			break;

			case 35:
				e.preventDefault();
				e.stopPropagation();
				link.closest('.js-submenu').find('a').last().focus();
				console.log("35");
			break;

			case 36:
				e.preventDefault();
				e.stopPropagation();
				link.closest('.js-submenu').find('a').first().focus();
				console.log("36");
			break;
			case 37:
				e.preventDefault();
				e.stopPropagation();
				if (link.closest('.js-submenu').hasClass('active')){
					var parentLink = link.closest('.js-main-menu').find('.menu-button');
					var position = parentLink.parent('li').prevAll('li').last().first().length;
					if(parentLink.parent('li').prevAll('li').filter(':visible').last().first().length == 0) {
						openMenu(parentLink.parent('li').nextAll('li').last());
						parentLink.parent('li').nextAll('li').last().find('.menu-button').focus();
						console.log(e.keyCode+"length 0");

					} else {
						console.log(e.keyCode+"othr way");
						openMenu(parentLink.parent('li').prevAll('li').first())
						//parentLink.parent('li').prevAll('li').first().find('.menu-button').focus();
						console.log(parentLink.closest('.js-main-menu').prev().find('.lists a[role="menuitem"]').first());

						setTimeout(() => {parentLink.closest('.js-main-menu').prev().find('.lists a[role="menuitem"]').first().focus();}, 100);
					}
				}
				else{
				}
				break;

			case 38:
				e.preventDefault();
				e.stopPropagation();
				if (link.parent('li').prevAll('li').filter(':visible').first().length == 0 ){
					if (link.parent('li').parent('ul').hasClass('list')){
						if (link.parent('li').parent('ul').prevAll('ul').length==0){
							link.closest('.js-submenu').find('a').last().focus();
						}
						else{
							link.parent('li').parent('ul').prev('ul').find('li').last().find('a').focus();
						}
					}
					if (link.hasClass('card__link')){
						link.parent('li').parent('ul').prevAll('.lists').last().find('ul').last().find('li').last().find('a').focus();
					}
				}
				else {
					link.parent('li').prevAll('li').filter(':visible').first().find('a').first().focus();
				}
				break;

				case 39:
					e.preventDefault();
					e.stopPropagation();
					var parentLink = link.closest('.js-main-menu').find('.menu-button');
					if (parentLink.parent('li').nextAll('li').length == 0){
						openMenu(parentLink.parent('li').prevAll().last());
						setTimeout(() => {parentLink.parent('li').prevAll().last().find('.js-submenu').find('a').first().focus();}, 100);
					} else {
						openMenu(parentLink.parent('li').next('li'));
						setTimeout(() => {parentLink.parent('li').next('li').find('.js-submenu').find('a').first().focus();}, 100);
					}
				break;

				case 40:
					e.preventDefault();
					e.stopPropagation();
					if(link.parent('li').nextAll('li').filter(':visible').first().length == 0){
						if (link.parent('li').parent('ul').hasClass('list')){
							link.parent('li').parent('ul').next('ul').find('li').first().find('a').focus();
							if (link.parent('li').parent('ul').nextAll('ul').length == 0){
								link.parent('li').parent('ul').parent('div').next('.cards').find('li').first().find('a').focus();
							}
						}
						if (link.hasClass('card__link')){
							link.parent('li').parent('ul').prevAll('.lists').first().find('ul').first().find('li').first().find('a').focus();
						}
					}
					else {
						link.parent('li').nextAll('li').filter(':visible').first().find('a').first().focus();
					}
					break;

				case 32:
					e.preventDefault();
					e.stopPropagation();
					link.trigger("click");
				break;

				default:
					var value = String.fromCharCode(e.keyCode).toLowerCase();
					var refocused = false;

					if (refocused == false){
						link.parent('li').nextAll('li').each( function() {
							if (value == $(this).find('.link__content').text().substring(0,1).toLowerCase()){
								$(this).find('a').focus();
								refocused = true;
								return false;
							}
							if (value == $(this).find('a').text().substring(0,1).toLowerCase()){
								$(this).find('a').focus();
								refocused = true;
								return false;
							}
						});
						if (refocused == false){
							link.parent('li').parent('ul').nextAll('ul').each( function() {
								$(this).find('li').each( function() {
									if (value == $(this).find('.link__content').text().substring(0,1).toLowerCase()){
										$(this).find('a').focus();
										refocused = true;
										return false;
									}
									if (value == $(this).find('a').text().substring(0,1).toLowerCase()){
										$(this).find('a').focus();
										refocused = true;
										return false;
									}
								});
								if (refocused == true){
									return false;
								}
							});
						}
					 if (refocused == false){
						 if (value == link.parent('li').parent('ul').parent('div').next('.cards').find('li').first().find('.link__content').text().substring(0,1).toLowerCase()){
							 link.parent('li').parent('ul').parent('div').next('.cards').find('li').first().find('a').focus();
							 refocused = true;
							 return false;
						 }
						 if (value == link.parent('li').parent('ul').parent('div').next('.cards').find('li').first().next('li').find('.link__content').text().substring(0,1).toLowerCase()){
							 link.parent('li').parent('ul').parent('div').next('.cards').find('li').first().next('li').find('a').focus();
							 refocused = true;
							 return false;
						 }
						 if (value == link.parent('li').parent('ul').parent('div').next('.cards').find('li').last().find('.link__content').text().substring(0,1).toLowerCase()){
							 link.parent('li').parent('ul').parent('div').next('.cards').find('li').last().find('a').focus();
							 refocused = true;
							 return false;
						 }
						}
						if (refocused == false){
							link.closest('.js-submenu').find('a').each( function () {
								if (value == $(this).text().substring(0,1).toLowerCase()){
									$(this).focus();
									refocused = true;
									return false;
								}
							});
						}
						if (refocused == false){
							link.closest('.js-submenu').find('.link__content').each( function () {
								if (value == $(this).text().substring(0,1).toLowerCase()){
									$(this).closest('a').focus();
									refocused = true;
									return false;
								}
							});
						}
					 }
				break;
		}
	});

	function openMenu($menu){
	if (!$menu.find('.menu-button').hasClass('active') && !$menu.find('.js-submenu').hasClass('active')){
		closeOtherSubs($(this));
		$menu.find('.menu-button').attr('aria-expanded', 'true');
		$menu.find('.js-submenu').show();
		$menu.find('.js-submenu').addClass('active');
		$menu.find('.menu-button').addClass('active');
	} else {
		$menu.find('.menu-button').attr('aria-expanded', 'false');
		$menu.find('.js-submenu').hide();
		$menu.find('.js-submenu').removeClass('active');
		$menu.find('.menu-button').removeClass('active');
	}
	}

	$mainMenu.each(function () {
		$(this).on('click', function(event){
				openMenu($(this));
		});
	});

	//video handler
	//triggers video to play
	$('.video__link').each( function() {
		$(this).on('click', function() {
			var $target = $(this).closest('.video').find('.ytvideo[data-video]').first();
			console.log($target);
			$target.trigger('click');
			$(this).remove();
			console.log('button pressed');
		})
	})

	// may be redundant, but allows an image/video switch when icon/video__link is and is not present
	$('.ytvideo[data-video]').each(function() {
		$(this).one('click', function() {
			console.log('triggered video');
			$(this).closest('.video').addClass('active');
			$('<iframe allow="autoplay" width="640" height="390" src="' + $(this).data("video") + '?&autoplay=1"></iframe>').insertBefore($(this).closest('.photo.shadow'));
			$(this).closest('.photo.shadow').remove();
		})
	})

	// URLS to filters
	let $urlFilters = $("[data-url-ref]");
	let updateFilter = function () {
		let params = queryString.parse(location.search);
		$urlFilters.each ( function (index, element) {
			let $this = $(this);
			let name = $this.data("url-ref");
			let trigger = $this.data("url-ref-trigger");
			console.log($this.attr("aria-pressed"));
			if ($this.attr("type") == "text") {
				let value = $this.val();
				if (value.replace(" ", "").length > 2) {
					params[name] = value;
				}
				else {
					delete params[name];
				}
			}
			else {
				if ($this.prop("checked") || $this.is(document.activeElement)) { // if we're actually clicking the dang thing
					params[name] = null;
				}
				else {
					delete params[name];
				}
			}
		});
		let stringified = queryString.stringify(params);
		window.history.replaceState(null, "", location.origin + location.pathname + "?" + stringified);
	};
	$urlFilters.each ( function (index, element) {
		let $this = $(this);
		let name = $this.data("url-ref");
		let params = queryString.parse(location.search);
		let trigger = $this.data("url-ref-trigger");
		if (name in params) {
			if ($this.attr("type") == "text") {
				$this.val(params[name]);
				if (trigger) {
					$("#"+trigger).click();
				}
			}
			else {
				$this.click();
			}
		}

		if (trigger) {
			$("#"+trigger).on("click", updateFilter);
		}
		else {
			$this.on("click change", updateFilter);
		}

	});

	// on grid layouts control placement on amounts less than 3 to create a balanced layout
	$('.cards__inner').each( function() {
		var $count = $(this).find('li').length;
		if ($count == 1){
			$(this).find('li').first().css("grid-column-start","2");
		}
	});

	// Single Degree Program Template, if a section has only one infographic post load, remove class that styles infographic as column in order to auto-style/center the infographic
	$('.section__cols').each( function() {
		var $count = $(this).find('.col--size3').length;
		if ($count == 1) {
			$(this).find('.col--size3').first().addClass('col').removeClass('col--size3');
		}
	});

	// fix for ios applying native styling to dropdown menu
	$('.has_state').each( function() {
		$(this).find('.address_state').each( function() {

		// container select styling will add arrow, some state containers are text so added a check for select here
		if ($(this).find('select').length != 0) {
				$(this).addClass('container--select');
		}
		$(this).find('select').first().addClass('vtc--select');
		})
	})

	$('.container--select').each( function() {
		// If a label is found inside the state/dropdown object a different class must be applied in order to protect the styling
		if ($(this).find('label').length == 1) {
			// proper gray separator position is based on whether the label occurs above or below the element in question
			if ($(this).find('select, input').prevAll('label').length > 0) {
				$(this).addClass('label-contained-before');
			} else {
				$(this).addClass('label-contained-after');
			}
		}
		$(this).find('select').addClass('vtc--select');
	})

	// fix for only first radio item being highlighted on Safari
	$('input:radio').each( function() {
		$(this).attr('tabindex', '0');
	})

	$('.radios').each( function() {
		$(this).find('input:radio').first().attr('tabindex', '0');
		$(this).find('.radio').first().nextAll('.radio').each( function() {
			$(this).find('input:radio').attr('tabindex', '-1');
		})
	})

	// interior page formatting
	$(".page-template-default .section__main > p:first-child").addClass("standout-text color-graydark fw-md").wrapInner("<strong></strong>");
  $(".page-template-default .highlight--reverse.bg-trans h3").addClass("article__subtitle");
  $(".page-template-default .highlight--reverse.bg-trans a").addClass("link color-blue fw-bd");
  $(".page-template-default .highlight.bg-blue .article__content > *").addClass("color-white");
  $(".page-template-default .section__main img.alignright, .section__main img.alignleft").each(function() {
      $this = $(this);
      if ($this.parent().children().length == 1) {
          if ($this.hasClass("alignright")) {
              $this.parent().addClass("alignright");
          }
          else {
              $this.parent().addClass("alignleft");
          }
          $this.removeClass("alignleft alignright");
      }
  });

	$('img:not([alt])').attr('alt', '""');

	$('.gridtabs .section__notes strong, .gridtabs .section__notes b').addClass('fw-bd');

	$('.gfield_label').each( function() {
		if ($(this).find('.gfield_required').length == 0) {
			if ($(this).text().endsWith("*")) {
				var $text = $(this).text().slice(0 ,-1);
				$(this).text($text);
				$(this).append("<span class='gfield_required'><span class='gfield_required gfield_required_asterisk'> * </span> </span>");
				console.log('required appended');
			} else {
				return false;
			}
		} else {
			return false;
		}
	});

	$('.gfield_contains_required .gfield_label').each( function() {
		if ($(this).find('.gfield_required').length == 0) {
			if ($(this).text().endsWith("*")) {
				var $text = $(this).text().slice(0 ,-1);
				$(this).text($text);
				$(this).append("<span class='gfield_required'><span class='gfield_required gfield_required_asterisk'> * </span> </span>");
				console.log('required appended');
			} else {
				return false;
			}
		} else {
			return false;
		}
	});


})(window, document, window.jQuery);

$(window).bind("load", function() {
    // filetype link marking
    let filetypes = ["pdf", "xlsx", "zip"];
    $.each(filetypes, function (index, filetype) {
        $("a[href$='."+filetype+"']").each(function () {
            if ($(this).parent().hasClass('article__actions') || $(this).parent().hasClass('highlight__actions')) {
                let $this = $(this);
                let $textEl = $this;
                let $linkContent = $this.find(".btn__text");
                if ($linkContent.length > 0) {
                    $textEl = $linkContent;
                }
                let text = $textEl.text().replace(/^\s+|\s+$/g, '');
                let bigFiletype = filetype.toUpperCase();
                $textEl.text(text + " ("+bigFiletype+")");
                return;
            }
            let $this = $(this);
            let $textEl = $this;
            let $linkContent = $this.find(".link__content");
            if ($linkContent.length > 0) {
                $textEl = $linkContent;
            }
            let $ornament = $textEl.find(".link__arrow, .wp_ada_hidden").detach();
            let text = $textEl.text().replace(/^\s+|\s+$/g, '' );
            let bigFiletype = filetype.toUpperCase();
            if (text.indexOf(filetype) == -1 && text.indexOf(bigFiletype) == -1 ) {
                $textEl.text(text + " ("+bigFiletype+")");
                $textEl.append($ornament);
            }
        });

    });
});
